const onPageNumberClick = (event) => {
    const $container = $('.media-center-content-container');
    const $page = parseInt($(event.currentTarget).text(), 10);
    $container.attr('data-page', $page);
    // eslint-disable-next-line no-use-before-define
    getAjaxMediaPosts();
    event.target.classList.add('active');
};

const setupMediaCenterPagination = () => {
    const $container = $('.media-center-content-container');
    const page = $('.media-center-content-container').attr('data-page');
    const $currentPage = parseInt(page, 10);
    const $totalPages = parseInt(
      $container.attr('data-totalpages'),
      10,
    );
    const $paginationContainer = $container.find('.cf-pagination');
    const $pagination = $paginationContainer.find('.pages');
    const prev = $paginationContainer.find('.prev');
    const next = $paginationContainer.find('.next');

    $pagination.empty();
    $('.cf-pagination .prev, .cf-pagination .next').hide()

    if ($totalPages < 2) {
      return;
    }
    if ($currentPage === 1) {
      prev.hide();
    } else {
      prev.show();
    }

    if ($currentPage === $totalPages) {
      next.hide();
    } else {
      next.show();
    }

    for (let i = 1; i <= $totalPages; i += 1) {
      const active = $currentPage === i ? 'active' : '';
      const $p = `<span class="${active}">${i}</span>`;
      $pagination.append($p);
    }

    $pagination.find('> span').on('click', (event) => onPageNumberClick(event));
};

const getAjaxMediaPosts = () => {
    const $container = $('.media-center-content-container');
    const $contentArea = $container.find('.filtered-content');
    const params = {};
    const page = $container.attr('data-page');
    const perpage = $container.attr('data-perpage');
    const filters = $('select.media-center-taxonomy-filter');
    const nonce = $container.attr('data-nonce');

    $container.addClass('loading');
    $contentArea.empty();

    $(filters).each((index, el) => {
      const $value = $(el).find('option:selected').val();
      const $name = $(el).attr('name');
      params[$name] = $value;
    });

    $.ajax({
      url: victaulicThemeVars.ajaxUrl,
      type: 'POST',
      data: {
        action: 'victaulic_filter_media',
        params,
        nonce,
        page,
        perpage,
        query: victaulicThemeVars.query_vars, // Defined by 'wp_localize_script'
      },
      success(response) {
        $container.removeClass('loading');
        if (response.success) {
          $contentArea.html(response.data.content);
          $container.attr('data-totalpages', response.data.pages ? response.data.pages : 0);
          setupMediaCenterPagination();
        }
      },
    });
};

const onPaginationClickNext = (container) => {

    const $container = $(container);
    let $page = $container.attr('data-page');
    const $totalPages = $container.attr('data-totalpages');
    $page = parseInt($page, 10) + 1;

    if ($page > $totalPages) {
      $page = $totalPages;
    }
    $container.attr('data-page', $page);
    getAjaxMediaPosts();
};

const onPaginationClickPrev = (container) => {
    const $container = $(container);
    let $page = $container.attr('data-page');
    $page = parseInt($page, 10) - 1;

    if ($page < 1) {
        $page = 1;
    }
    $container.attr('data-page', $page);
    getAjaxMediaPosts();
};

const initMediaCenterTaxFilter = () => {
    const $container = $('.media-center-content-container');

    if ($container.length) {
      getAjaxMediaPosts();
    }

    $('.media-center-taxonomy-filter')
      .select2()
      .on('change', () => {
        getAjaxMediaPosts();
      });

    $('.cf-pagination .next').on('click', function(){
      onPaginationClickNext($container);
    });
    $('.cf-pagination .prev').on('click', function(){
      onPaginationClickPrev($container);
    });
};

const initMediaCenterMobileToggles = () => {
    $('.media-center-menu-toggle').on('click', () => {
      $('.vtc-left-menu').toggleClass('active');
    });

    $('.media-center-filter-toggle').on('click', (event) => {
      $('.media-center-taxonomy-filters').toggleClass('active');
      $(event.currentTarget).find('a').toggleClass('active');
    });

};

// eslint-disable-next-line no-unused-vars
(($) => {
  $(document).ready(() => {
    initMediaCenterTaxFilter();
    initMediaCenterMobileToggles();
  });
})(jQuery);
